<!--#region dynamictag-->
<div class="input-group input-group-sm">
  <input [id]="getId(input)" [attr.type]="input.MainElementList[0].Type" class="col q-input-border q-bo"
         aria-label="Small" attr.aria-describedby="{{getId(input)}}-btn"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="input.MainElementList[0].Value"
         [ngClass]="setClass(input)">
  <div *ngFor="let button of input?.MainElementList?.slice(1)" class="input-group-append">
    <button *ngIf="button.Type === 'BUTTON'"
            class="q-btn q-bo q-main p-0"
            (click)="OnButtonClicked(button, Modal);"
            [id]="button?.ID ? button?.ID : ''"
            [title]="button?.Tooltip ? button?.Tooltip : ''">
      <i class="{{button.Src}}"></i>
    </button>
  </div>
</div>
<!--#endregion-->

<ng-template #Modal let-modal>

  <!--#region header-->
  <div class="modal-header w-100">
    <h5 class="modal-title big-title" id="modal-title">Fiche création client My company files</h5>

    <button type="button" class="close" aria-label="Close" (click)="modal.close('CANCEL')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <!--#endregion-->

  <!--#region body-->
  <div class="modal-body overflow-auto">
    <q-config-client-mcf [group]="group" [storage]="storage" [idClient]="model?.IdDonneeFils" (save)="Save(modal, $event)"></q-config-client-mcf>
  </div>
  
  <!--#endregion-->
  <datalist id="datalist-props">
    <option value="CodeClient">
    <option value="Siret">
    <option value="Activité">
    <option value="Adresse">
    <option value="Ville">
    <option value="Code Postal">
    <option value="Régime TVA">
    <option value="Date de TVA">
    <option value="Forme Juridique">
    <option value="Mission sociale">
    <option value="Régime fiscal">
  </datalist>
</ng-template>
